import { getKsdmConfig } from 'helpers/index';

/**
 * footer#ksdm-footer — reports board variant (templates/reportBase.html:22-26):
 * a single `div.col-xs-10.col-xs-offset-2` directly wrapping the shared
 * common/footer.html content (no .footer-wrapper layer, unlike the other
 * boards — hence a local component).
 *
 * The left-menu resizer swaps the wrapper classes: checked (collapsed menu) →
 * `to-left`, unchecked → `col-xs-10 col-xs-offset-2` (view/main.js
 * move_footer :79-88).
 */
const ReportsBoardFooter = ({ menuCollapsed }: { menuCollapsed: boolean }) => {
  const cfg = getKsdmConfig();
  const year = cfg?.year ?? new Date().getFullYear();
  const software = cfg?.versions?.software;
  const master = cfg?.versions?.master;
  const cmsVersion = cfg?.versions?.cms;

  return (
    <footer id="ksdm-footer">
      <div className={menuCollapsed ? 'to-left' : 'col-xs-10 col-xs-offset-2'}>
        <div className="text-right">
          <small id="ksdm-copyright" className="right mt-0">
            Powered by Kinetix Air | &#169; {year} Kinetix Software LLC | All Rights Reserved
          </small>
        </div>
        {software && (
          <div className="">
            <small id="ksdm-dbs-version" className="mt-0">
              <span className="ka-has-tooltip" tooltip="Software version">
                {software}
              </span>{' '}
              |{' '}
              <span className="ka-has-tooltip" tooltip="Master DB version">
                {master}
              </span>
              {cmsVersion && (
                <>
                  {' '}
                  |{' '}
                  <span className="ka-has-tooltip cms_version" tooltip="CMS DB version">
                    {cmsVersion}
                  </span>
                </>
              )}
            </small>
          </div>
        )}
      </div>
    </footer>
  );
};

export default ReportsBoardFooter;
